import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../baseClasses/BaseComponent';
import SelectMemberList from './SelectMemberList';
import SelectCompanyComboBox from '../../../components/SelectCompanyComboBox';
import SearchBar from '../../../components/SearchBar/SearchBar';
import { filterUsers } from '../../../components/SearchBar/utils/searchUtils';
import dataModel from '../../../models/DataModel';
import './SelectTeamMembers.scss';
import LoadingDots from '../../../components/LoadingDots';

export class SelectTeamMembers extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      menu: null,
      editing: false,
      userSearchTerm: '',
      filteredUsers: [],
    };

    this.createSelectedUserList = this.createSelectedUserList.bind(this);
    this.createUserSelectionList = this.createUserSelectionList.bind(this);
    this.handleUserSearchChange = this.handleUserSearchChange.bind(this);
  }

  componentDidMount() {
    const { team } = this.props;
    this.setState({ team: _.cloneDeep(team) });

    dataModel.companiesDAO.getCompany(this.props.currentCompany.id,
      {
        recordDescriptor: {
          company: {
            vendor_companies: { additionalFields: ['is_vendor_company'] },
            additionalFields: ['logo'],
          },
        },
      }).then(teamCompany => {
        if (!teamCompany) {
          teamCompany = team.company;
        }
        let teamCompanies = [this.props.currentCompany];
        if (teamCompany.vendor_companies) {
          teamCompany.vendor_companies.forEach(vendor => {
            teamCompanies.push(vendor);
          });
        }
        this.setState({
          teamCompany: teamCompany,
          teamCompanies: teamCompanies,
          selectedCompany: teamCompanies.length > 0 ? teamCompanies[0] : null,
        });
      });

    const element = document.getElementById('select-team-members' + team.id);
    if (element) {
      element.addEventListener('keydown', this.handleKeyDown);
      element.focus();
    }
  }

  componentDidUpdate(prevProps) {
    const { team } = this.props;
    if (team != prevProps.team) {
      this.setState({ team: _.cloneDeep(team) });
    }
  }

  handleAddUser(user) {
    let { team } = this.state;
    const element = document.getElementById('select-team-members' + this.state.team.id);
    if (element) {
      element.focus();
    }
    const findUser = this.state.team.users.find(foundUser => {
      if (foundUser.id == user.id) {
        foundUser.toBeRemoved = false;
        return true;
      }
      return false;
    });

    user.toBeRemoved = false;
    if (!findUser) {
      user.toBeAdded = true;
      team.users.push(user);
    }

    if (this.props.handleManageTeamUsers) {
      this.props.handleManageTeamUsers(team);
    }
    this.setState({ team, editing: true });
  }

  handleFinishRemoveUser(user) {
    const { team } = this.state;
    const element = document.getElementById('select-team-members' + this.state.team.id);
    if (element) {
      element.focus();
    }

    let findUser;
    const deleteIndex = team.users.findIndex(selectedUser => user.id == selectedUser.id);
    if (deleteIndex >= 0) {
      findUser = team.users[deleteIndex];
      if (findUser.toBeAdded && deleteIndex >= 0) {
        team.users.splice(deleteIndex, 1);
      }
      else {
        findUser.toBeRemoved = true;
      }
    }

    if (this.props.handleManageTeamUsers) {
      this.props.handleManageTeamUsers(team);
    }

    this.setState({ team, editing: true });
  }

  handleRemoveUser(user) {
    const { team } = this.state;
    this.handleFinishRemoveUser(user, team);
  }

  handleSetVendorUsers(company, markets) {
    if (company.id != this.props.currentCompany.id && markets) {
      let vendor_users = [];

      markets.forEach(market => {
        market.vendor_users.forEach(
          vendorUser => {
            if (vendorUser.companies[0] == company.id) {
              vendor_users.push(vendorUser);
            }
          }
        );
      });
      this.setState({ vendorUsers: vendor_users });
    }
  }

  handleCompanySelection(company) {
    this.handleSetVendorUsers(company, this.state.team.markets);
    this.setState({ selectedCompany: company });
  }

  createSelectedUserList() {
    let selectedUsers = null;
    if (this.state.team.users) {
      selectedUsers = this.state.team.users.filter(user => {
        user.name = user.first_name + ' ' + user.last_name;
        if (user.companies && user.companies.length && (user.companies[0] == this.props.currentCompany.id || user.companies[0].id == this.props.currentCompany.id)) {
          return !user.toBeRemoved;
        }
        return !user.toBeRemoved;
      });

      selectedUsers.sort((u1, u2) => {
        if (u1.name.toLowerCase() < u2.name.toLowerCase()) {
          return -1;
        } else if (u1.name.toLowerCase() > u2.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return selectedUsers;
  }

  createUserSelectionList() {
    let users = [];
    const { team, selectedCompany } = this.state;
    if (team && selectedCompany && team.markets) {
      team.markets.forEach(market => {
        if (selectedCompany && selectedCompany.id == this.props.currentCompany.id && market.users) {
          market.users.forEach(user => {
            if (!user.suspended && !users.find(u => { return u.id == user.id; })) {
              users.push(user);
            }
          });
        }
        else {
          market.vendor_users.forEach(user => {
            if (selectedCompany && user.companies && user.companies.length > 0 &&
              (user.companies[0] == selectedCompany.id || user.companies[0].id == selectedCompany.id)) {
              if (!user.suspended && !users.find(u => { return u.id == user.id; })) {
                users.push(user);
              }
            }
          });
        }
      });
      let usersSelectionList = !users ? [] : users.filter(user => {
        const findUser = team.users ? team.users.find(teamUser => (teamUser.id == user.id && !teamUser.toBeRemoved)) : null;
        if (user.super_admin || findUser) {
          return false;
        }
        else {
          user.name = user.first_name + ' ' + user.last_name;
          return true;
        }
      });
      let sortedUsers = usersSelectionList.sort((u1, u2) => {
        return u1.name < u2.name ? -1 : u1.name > u2.name ? 1 : 0;
      });
      
      // Use filtered users if search term exists, otherwise use all users
      if (this.state.userSearchTerm) {
        return this.state.filteredUsers;
      }
      
      return sortedUsers;
    }
    return [];
  }

  handleUserSearchChange(searchTerm) {
    const availableUsers = this.getAvailableUsers();
    const filteredUsers = filterUsers(availableUsers, searchTerm);
    this.setState({ userSearchTerm: searchTerm, filteredUsers });
  }

  getAvailableUsers() {
    const { team, selectedCompany } = this.state;
    
    if (team && selectedCompany && team.markets) {
      let users = [];
      team.markets.forEach(market => {
        if (selectedCompany && selectedCompany.id == this.props.currentCompany.id && market.users) {
          market.users.forEach(user => {
            if (!user.suspended && !users.find(u => { return u.id == user.id; })) {
              users.push(user);
            }
          });
        }
        else {
          market.vendor_users.forEach(user => {
            if (selectedCompany && user.companies && user.companies.length > 0 &&
              (user.companies[0] == selectedCompany.id || user.companies[0].id == selectedCompany.id)) {
              if (!user.suspended && !users.find(u => { return u.id == user.id; })) {
                users.push(user);
              }
            }
          });
        }
      });
      let usersSelectionList = !users ? [] : users.filter(user => {
        const findUser = team.users ? team.users.find(teamUser => (teamUser.id == user.id && !teamUser.toBeRemoved)) : null;
        if (user.super_admin || findUser) {
          return false;
        }
        else {
          user.name = user.first_name + ' ' + user.last_name;
          return true;
        }
      });
      return usersSelectionList.sort((u1, u2) => {
        return u1.name < u2.name ? -1 : u1.name > u2.name ? 1 : 0;
      });
    }
    return [];
  }

  handleAddMembers() {
    let { team } = this.state;
    for (let user of this.state.team.users) {
      if (user.toBeAdded) {
        delete user.toBeAdded;
        this.addUserToTeam(user, team);
      }
      else if (user.toBeRemoved) {
        delete user.toBeRemoved;
        this.removeUserFromTeam(user, team);
      }
    }
  }

  // The next 2 functions are for updating the UI without having to wait on API requests
  addUserToTeam(user, team) {
    if (team.users && !team.users.find(usr => usr.id == user.id)) {
      team.users.push(user);
      this.setState({ team });
      if (this.props.handleManageTeamUsers) {
        this.props.handleManageTeamUsers(team);
      }
    }
  }

  removeUserFromTeam(user, team) {
    if (team.users && team.users.find(usr => usr.id == user.id)) {
      _.remove(team.users, usr => usr.id == user.id);
      this.setState({ team });
      if (this.props.handleManageTeamUsers) {
        this.props.handleManageTeamUsers(team);
      }
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleAddMembers();
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClose();
    }
  }

  render() {
    let { team } = this.state;
    if (team == undefined) {
      return null;
    }

    const companyOptions = this.state.teamCompanies ? this.state.teamCompanies.filter(vendor => {
      return true;
    }) : [];

    if (this.props.currentUser.companies[0].id == this.props.currentCompany.id) {
      companyOptions.splice(0, 0, this.props.currentCompany);
    }

    const selectedUsers = this.createSelectedUserList();
    const usersSelectionList = this.createUserSelectionList();

    return (
      <div id={'select-team-members' + this.props.team.id} className="select-team-members" style={{ display: this.props.visible ? 'block' : 'none' }}>
        <div className="main-body">
          <div className="left-side">
            <div className="selection-section company-section">
              <div className="label">{this.textMap.selectCompany}</div>
              <div className="combo-box-container">
                <SelectCompanyComboBox
                  id={'select-vendor-company-combobox'}
                  key={'select-vendor-company-combobox'}
                  backgroundIndex={27}
                  width={218}
                  hasBorder={true}
                  noBackground={false}
                  handleSelection={this.handleCompanySelection}
                  currentSelectedCompany={this.state.selectedCompany} adjustHeight={true} companies={companyOptions}
                />
              </div>
            </div>
            <div className="selection-section user-section">
              <div className="label taller">{this.textMap.selectMember}</div>
              <div className="search-bar-container">
                <SearchBar
                  placeholder="Search users..."
                  onSearchChange={this.handleUserSearchChange}
                  width="100%"
                  height="28px"
                  debounceMs={300}
                />
              </div>
              <SelectMemberList
                users={usersSelectionList}
                height={125}
                selectMember={this.handleAddUser}
              />
              {this.state.loadingMarkets && <LoadingDots />}
              <div className="instructions">Click to Add</div>
            </div>
          </div>
          <div className="right-side">
            <div className="selection-section user-section">
              <div className="label">{this.textMap.selectedMember}</div>
              <SelectMemberList
                users={selectedUsers}
                height={233}
                selectMember={this.handleRemoveUser}
              />
              <div className="instructions">{'Click to Remove'}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(SelectTeamMembers);



// WEBPACK FOOTER //
// ./src/components/TeamPopup/SelectTeamMembers/index.js